import { IPaymentRequestData } from "common/records/PaymentRequest";
import { ActionsUnion, createAction } from "common/reducers/UtilsTypes";

export const FETCH_PAYMENT_REQUEST = "@paymentRequest/FETCH_PAYMENT_REQUEST";
export const RECEIVE_PAYMENT_REQUESTS = "@paymentRequest/RECEIVE_PAYMENT_REQUESTS";
export const RECEIVE_PAYMENT_REQUEST = "@paymentRequest/RECEIVE_PAYMENT_REQUEST";
export const INIT_PAYMENT_REQUEST = "@paymentRequest/INIT_PAYMENT_REQUEST";
export const SET_LOADED = "@paymentRequest/SET_LOADED";
export const RESET_PAYMENT_REQUEST = "@paymentRequest/RESET_PAYMENT_REQUEST";

export const PaymentRequestActions = {
  fetchPaymentRequest: (id: number) => createAction(FETCH_PAYMENT_REQUEST, { id }),
  receivePaymentRequests: (paymentRequests: Partial<IPaymentRequestData>[]) =>
    createAction(RECEIVE_PAYMENT_REQUESTS, { paymentRequests }),
  receivePaymentRequest: (paymentRequest: Partial<IPaymentRequestData>) =>
    createAction(RECEIVE_PAYMENT_REQUEST, { paymentRequest }),
  initializePaymentRequest: () => createAction(INIT_PAYMENT_REQUEST, {}),
  setLoaded: (id: number) => createAction(SET_LOADED, { id }),
  resetPaymentRequest: (id: number) => createAction(RESET_PAYMENT_REQUEST, { id }),
};

export type PaymentRequestActions = ActionsUnion<typeof PaymentRequestActions>;
